<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-add-model">
  <div class="org-admin-add-model--layout">
    <app-org-admin-sidebar class="org-admin-add-model--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-add-model--content">
      <div class="org-admin-add-model--body">
        <app-page-header [showDivider]="false"></app-page-header>
      </div>
      <hr class="org-admin-add-model--title-divider" />
      <div class="org-admin-add-model--body">
        <div class="page-container">
          <lib-model-onboarding-home
            publisherRole="org-admin"
            (submitError)="onSubmitError($event)"
            (submitSuccess)="onSubmitSuccess($event)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
